import { pickBy } from 'lodash';
import { generateURL } from 'utils/helpers';

const entry = {
  getExperiences: ({ categoryIds, limit }) => {
    const url = generateURL('/entry/experiences', {
      category_ids: categoryIds,
      limit,
    });
    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },
  getEvents: ({ month, limit, site }) => {
    const queryParams = pickBy(
      { month, limit, site },
      (value) => value !== undefined
    );
    const url = generateURL('/entry/events', queryParams);
    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },
  getEventMonths: () => {
    const url = generateURL('/entry/event_months');
    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },
  getSpecialOffers: (params) => {
    const url = generateURL('/entry/special_offers', params);
    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },
};

export default entry;
